import React from "react";
import { Box, Typography } from "@mui/material";

function TimeDisplay({ remainingSeconds }) {
  const remaining = Math.max(0, Number(remainingSeconds) || 0);
  const time = {
    hours: Math.floor(remaining / 3600),
    minutes: Math.floor((remaining % 3600) / 60),
    seconds: remaining % 60,
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minWidth: "300px",
        padding: "16px",
        borderBottomLeftRadius: "12px",
        borderBottomRightRadius: "12px",
        background: "#2e64b8",
        color: "#fff",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
      }}
    >
      <Typography sx={{ fontWeight: "bold", fontSize: "1rem" }}>
        Time Remaining
      </Typography>
      <Typography variant="h6" sx={{ marginTop: "8px" }}>
        {time.hours > 0 && `${time.hours} hour${time.hours !== 1 ? "s" : ""}, `}
        {time.minutes > 0 &&
          `${time.minutes} minute${time.minutes !== 1 ? "s" : ""}, `}
        {time.seconds} second{time.seconds !== 1 ? "s" : ""}
      </Typography>
    </Box>
  );
}

export default TimeDisplay;
